import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class ZipCodeInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'ZipCode',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = this.randomZipCode()
  }

  randomZipCode () {
    // Random 7-digit zip code
    return Math.floor(1000000 + Math.random() * 9000000)
  }
}
